import { render } from "./MDrawer.vue?vue&type=template&id=1fd5d26e&scoped=true"
import script from "./MDrawer.vue?vue&type=script&lang=js"
export * from "./MDrawer.vue?vue&type=script&lang=js"

import "./MDrawer.vue?vue&type=style&index=0&id=1fd5d26e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fd5d26e"]])

export default __exports__